import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import palette from '@/theme/palette.ts';

export const IsActiveStatusCell = ({ status }: { status: boolean }) => {
  const { t } = useTranslation();
  const statusColor = status ? palette.text.green : palette.text.primaryColor;

  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      sx={{ width: '100%', height: '100%' }}
    >
      <Typography variant={'body2'} sx={{ color: statusColor }}>
        {status ? t(`STATUS.ACTIVE`) : t(`STATUS.INACTIVE`)}
      </Typography>
    </Stack>
  );
};
